export default {
  title: 'Order configurator',
  newOrder: 'Check our offer',
  newOrderTooltip: 'Click here to find out the cost of repacking our current portfolio',
  customOrder: 'Describe your copacking brief',
  customOrderTooltip: 'Click here to create a custom repackaging form',
  choose: 'Choose an option',
};
